import styled from 'styled-components';

import { media } from '@minerva-analytics/pantheon';

import { BLUE, WHITE } from 'root/theme';

import bkgdDesktop from '../../assets/img/quizhive_hero_desktop.jpg';
import bkgdMobile from '../../assets/img/quizhive_hero_mobile.jpg';

const HeroContainer = styled.div`
  position: relative;
  background-image: url(${bkgdDesktop});
  background-color: ${BLUE};
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  margin-top: 50px;
  padding: 65px 0 50px 0;
  border-bottom: 3px solid ${WHITE};

  ${media.tablet`
    background-position: top center;
    background-image: url(${bkgdMobile});
    height: 900px;
  `}
`;

const HeroInnerContent = styled.div`
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  display: flex;
`;


export {
  HeroContainer,
  HeroInnerContent,
};
